import { Col, Form } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import * as yup from 'yup';
import { CampoFormik } from '../../../components/CompUtils';
import es from '../../../yup-es';
import { cvTiposSelector } from '../cvSlice';
import FormikContainer from './FormikContainer';

yup.setLocale(es);

//
// ─── SCHEMA CAPACITACIONES ────────────────────────────────────────────────
//

const CapacitacionesSchema = yup
  .object({
    idCursoCv: yup.number(),
    nombre: yup.string().required(),
    idPais: yup.number().required(),
    duracion: yup.number().required(),
    institucion: yup.string().required(),
    idTipoCurso: yup.number().required(),
  })
  .shape(
    {
      f_inicio: yup
        .date()
        .required('La fecha de ingreso es requerida')
        .test('valid-date', 'Fecha de ingreso inválida', (value) => {
          if (value) {
            const year = value.getFullYear().toString();
            const month = (value.getMonth() + 1).toString().padStart(2, '0');
            const day = value.getDate().toString().padStart(2, '0');
            return (
              year >= '1000' &&
              year <= '9999' &&
              month >= '01' &&
              month <= '12' &&
              day >= '01' &&
              day <= '31'
            );
          }
          return true;
        }),
      f_fin: yup
        .date()
        .nullable()
        .transform((curr, orig) => (orig === '' ? null : curr))
        .when(
          'f_inicio',
          (ingreso, schema) =>
            ingreso &&
            yup
              .date()
              .test('valid-date', 'Fecha de egreso inválida', (value) => {
                if (value) {
                  const year = value.getFullYear().toString();
                  const month = (value.getMonth() + 1).toString().padStart(2, '0');
                  const day = value.getDate().toString().padStart(2, '0');
                  return (
                    year >= '1000' &&
                    year <= '9999' &&
                    month >= '01' &&
                    month <= '12' &&
                    day >= '01' &&
                    day <= '31'
                  );
                }
                return true;
              })
              .min(yup.ref('f_inicio'), 'Rango de fechas incorrecto'),
        ),
    },
    ['f_inicio', 'f_fin'],
  );

//
// ─── FORMULARIO CAPACITACIONES ──────────────────────────────────────────────────
//

export const FormCapacitaciones = ({ formState }) => {
  const tiposCursos = useSelector(cvTiposSelector).tiposCursos;
  return (
    <FormikContainer
      schema={CapacitacionesSchema}
      seccionKey="capacitacion"
      seccionTitle="Actividad de capacitación">
      {(formik) => (
        <>
          <Form.Row>
            <CampoFormik
              aria-required
              label="Denominación de la actividad o certificación (obligatorio)"
              name="nombre"
              formik={formik}
            />
          </Form.Row>
          <Form.Row>
            <CampoFormik
              aria-required
              label="Establecimiento o Institución (obligatorio)"
              name="institucion"
              formik={formik}
            />
          </Form.Row>
          <Form.Row>
            <CampoFormik
              aria-required
              type="pais"
              label="Pais (obligatorio)"
              name="idPais"
              formik={formik}
            />
          </Form.Row>
          <Form.Row>
            <Form.Group as={Col}>
              <Form.Label for="tipoCapacitacion">Tipo de capacitación (obligatorio):</Form.Label>
              <Form.Control
                aria-required
                id="tipoCapacitacion"
                as="select"
                value={formik.values.idTipoCurso}
                name="idTipoCurso"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                isInvalid={formik.touched.idTipoCurso && !!formik.errors.idTipoCurso}>
                <option value="">Seleccione</option>
                {Object.keys(tiposCursos).map((key) => (
                  <option value={tiposCursos[key].id} key={tiposCursos[key].id}>
                    {tiposCursos[key].nombre}
                  </option>
                ))}
              </Form.Control>
              <Form.Control.Feedback type="invalid">
                {formik.errors.idTipoCurso}
              </Form.Control.Feedback>
            </Form.Group>
          </Form.Row>
          <Form.Row>
            <CampoFormik
              aria-required
              type="number"
              label="Duración (en horas, obligatorio)"
              name="duracion"
              inputClass="col-sm-3"
              formik={formik}
            />
          </Form.Row>
          <Form.Row>
            <CampoFormik
              aria-required
              label="Fecha de inicio (obligatorio)"
              name="f_inicio"
              col={{ sm: 6 }}
              type="date2"
              maxDate={formik.values.f_fin}
              formik={formik}
            />
            <CampoFormik
              aria-required
              label="Fecha de finalización (obligatorio)"
              name="f_fin"
              col={{ sm: 6 }}
              type="date2"
              formik={formik}
              minDate={formik.values.f_inicio}
            />
          </Form.Row>
        </>
      )}
    </FormikContainer>
  );
};
